import apiClient from './api';
import { withReferral } from '../utils/contestReferral';

const authApi = {
    // Login
    login: (credentials) => {
        return apiClient.post('/api/auth/login', credentials);
    },

    // Register
    register: (userData) => {
        return apiClient.post('/api/auth/register', withReferral(userData));
    },

    // Get current user
    getCurrentUser: () => {
        return apiClient.get('/api/auth/me');
    },

    // Update profile
    updateProfile: (profileData) => {
        return apiClient.put('/api/auth/profile', profileData);
    },

    // Send a verification code to the email being verified on the profile page
    sendProfileEmailOtp: (data) => {
        return apiClient.post('/api/auth/send-profile-email-otp', data);
    },

    // Verify the profile email code (saves email + marks verified)
    verifyProfileEmailOtp: (data) => {
        return apiClient.post('/api/auth/verify-profile-email-otp', data);
    },

    // Upload profile picture
    uploadProfilePicture: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return apiClient.post('/api/auth/profile/picture', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    // Change password
    changePassword: (passwordData) => {
        return apiClient.post('/api/auth/change-password', passwordData);
    },

    // Logout. `token` closes a session that is not in the store yet (e.g. one the server just opened for a role the web app refuses).
    logout: (token) => {
        return apiClient.post('/api/auth/logout', null, token ? { headers: { Authorization: `Bearer ${token}` } } : undefined);
    },

    // Multi-device: list this user's logged-in devices
    listSessions: () => {
        return apiClient.get('/api/auth/sessions');
    },

    // Multi-device: remove (log out) one device by id
    removeSession: (id) => {
        return apiClient.delete(`/api/auth/sessions/${id}`);
    },

    // Multi-device: log out all other devices except the current one
    revokeOtherSessions: () => {
        return apiClient.post('/api/auth/sessions/revoke-others');
    },

    // Delete (deactivate) own account — requires password confirmation
    deleteAccount: (passwordData) => {
        return apiClient.delete('/api/auth/account', { data: passwordData });
    },

    // Send OTP
    sendOtp: (data) => {
        return apiClient.post('/api/auth/send-otp', data);
    },

    // Verify OTP
    verifyOtp: (data) => {
        return apiClient.post('/api/auth/verify-otp', data);
    },

    // Complete registration after OTP verification
    completeRegistration: (data) => {
        return apiClient.post('/api/auth/register', withReferral(data));
    },

    // Verify OTP and log in (unverified user redirected from login)
    verifyAndLogin: (data) => {
        return apiClient.post('/api/auth/verify-and-login', data);
    },

    // Pre-register: save unverified user + send SMS OTP
    preRegister: (data) => {
        return apiClient.post('/api/auth/pre-register', data);
    },

    // [TEMPORARY - OTP BYPASS] Direct register without phone verification.
    // To re-enable OTP: remove this method and restore preRegister + OTP flow in RegisterPage.
    directRegister: (data) => {
        return apiClient.post('/api/auth/direct-register', data);
    },

    // Continue with Google: sign up (new verified email) or sign in (email already registered)
    googleAuth: (data) => apiClient.post('/api/auth/google', withReferral(data)),

    // Change phone number during registration
    changeRegistrationPhone: (data) => {
        return apiClient.post('/api/auth/change-registration-phone', data);
    },

    // Send OTP via email during registration
    sendRegistrationEmailOtp: (data) => {
        return apiClient.post('/api/auth/send-registration-email-otp', data);
    },

    // Forgot password
    forgotPassword: (data) => {
        return apiClient.post('/api/auth/forgot-password', data);
    },

    // Reset password
    resetPassword: (data) => {
        return apiClient.post('/api/auth/reset-password', data);
    },

    // Update user plan (free/pro) by phone
    updatePlan: (data) => {
        return apiClient.post('/api/user/update-plan', data);
    },
};

export default authApi;
